import { render, staticRenderFns } from "./DmaZonesStatisticsModal.vue?vue&type=template&id=0f1d3196&scoped=true&"
import script from "./DmaZonesStatisticsModal.vue?vue&type=script&lang=js&"
export * from "./DmaZonesStatisticsModal.vue?vue&type=script&lang=js&"
import style0 from "./DmaZonesStatisticsModal.vue?vue&type=style&index=0&id=0f1d3196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1d3196",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VDataTable,VRow,VTabItem})
